import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiAxios from 'helpers/apiAxios';

const URL = '/booking/travel/dashboard';

export const getTravelDashboard = createAsyncThunk(
  'TravelDashboard/get',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(URL, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: 'Failed to load travel dashboard' });
    }
  },
);

export const getTravelDrilldown = createAsyncThunk(
  'TravelDashboard/drilldown',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(`${URL}/drilldown`, { params });
      return response.data || { rows: [], total_rows: 0 };
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: 'Failed to load detail' });
    }
  },
);

export const exportTravelDrilldown = createAsyncThunk(
  'TravelDashboard/drilldownExport',
  async (params) => {
    const response = await apiAxios.get(`${URL}/drilldown_export`, { params, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `travel-detail-${params?.dimension || 'all'}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
);

// Server-side paginated travel-booking transactions for the dashboard grid.
export const getTravelDashboardTransactions = createAsyncThunk(
  'TravelDashboard/transactions',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(`${URL}/transactions`, { params });
      return response.data || { rows: [], total_rows: 0 };
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: 'Failed to load transactions' });
    }
  },
);

const initialState = {
  data: { stats: {}, by_status: [], by_purpose: [], by_type: [], monthly_trend: [], upcoming: [] },
  loading: false,
  error: null,
};

const travelDashboardSlice = createSlice({
  name: 'travel_dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTravelDashboard.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(getTravelDashboard.fulfilled, (state, action) => { state.loading = false; state.data = action.payload; })
      .addCase(getTravelDashboard.rejected, (state, action) => { state.loading = false; state.error = action.payload?.message; });
  },
});

export default travelDashboardSlice.reducer;
